import React, { useEffect, useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'

const ConsentUpdateModal = ({ show, firstName = 'there', onClose, onSubmit, showAllConsents = false }) => {
  const consentItems = showAllConsents
    ? [
        { id: 'terms', key: 'termsOfService', label: 'Terms of Service', href: 'https://www.tbd.health/terms' },
        { id: 'privacy', key: 'privacyPolicy', label: 'Privacy Policy', href: 'https://www.tbd.health/privacy-policy' },
        { id: 'telehealth', key: 'telehealthConsent', label: 'Telehealth Consent', href: 'https://www.tbd.health/consent-to-telehealth' },
        { id: 'prep', key: 'prepConsent', label: 'PrEP Consent (if applicable)', href: 'https://www.tbd.health/prep-consent' },
        { id: 'pep', key: 'pepConsent', label: 'PEP Consent (if applicable)', href: 'https://www.tbd.health/pep-consent' },
        { id: 'identity', key: 'identityVerificationTruthfulness', label: 'Identity Verification & Truthfulness Consent', href: 'https://www.tbd.health/identity-consent' },
      ]
    : [
        { id: 'prep', key: 'prepConsent', label: 'PrEP Consent', href: 'https://www.tbd.health/prep-consent' },
        { id: 'identity', key: 'identityVerificationTruthfulness', label: 'Identity Verification & Truthfulness Consent', href: 'https://www.tbd.health/identity-consent' },
      ]

  const [consentState, setConsentState] = useState({})

  useEffect(() => {
    if (!show) {
      setConsentState({})
      return
    }
    const resetState = consentItems.reduce((acc, item) => {
      acc[item.id] = false
      return acc
    }, {})
    setConsentState(resetState)
  }, [show, showAllConsents])

  const allChecked = consentItems.every(item => consentState[item.id])

  const handleToggle = (id, checked) => {
    setConsentState(prev => ({ ...prev, [id]: checked }))
  }

  const handleSubmit = () => {
    if (!allChecked) return
    const timestamp = new Date().toISOString()
    const consentsPayload = consentItems.reduce((acc, item) => {
      acc[item.key] = timestamp
      return acc
    }, {})
    if (typeof onSubmit === 'function') {
      onSubmit(consentsPayload)
    } else if (typeof onClose === 'function') {
      onClose()
    }
  }

  return (
    <Modal
      show={show}
      onHide={() => {}}
      keyboard={false}
      backdrop="static"
      onClick={e => e.stopPropagation()}
      animation={false}
      size="lg"
      aria-labelledby="consent-update-modal"
      centered
      dialogClassName="consent-modal__dialog"
      contentClassName="consent-modal__content modal-content"
      backdropClassName="consent-modal__backdrop"
      className="consent-modal"
    >
      <div className="consent-card">
        <div className="consent-card__inner">
          <div className="consent-card__tag">Action needed</div>
          <h2 id="consent-update-modal" className="consent-card__title">
            Updates to TBD Health consents
          </h2>
          <p className="consent-card__greeting">Hi {firstName || 'there'},</p>
          <p className="consent-card__copy">
            Thanks for trusting TBD Health. We've added a few more consents to our process. Please review them below and check the boxes if you agree. This keeps
            your access to TBD's services active.
          </p>

          <div className="consent-card__box">
            {consentItems.map(item => (
              <Form.Check
                key={item.id}
                type="checkbox"
                id={`${item.id}-consent-checkbox`}
                className="consent-card__checkbox"
                label={
                  <span>
                    {item.label}{' '}
                    <a href={item.href} target="_blank" rel="noreferrer">
                      (view)
                    </a>
                  </span>
                }
                checked={!!consentState[item.id]}
                onChange={e => handleToggle(item.id, e.target.checked)}
              />
            ))}
          </div>

          <p className="consent-card__note">
            If you have questions, please let us know.
            <br />
            All the best,
            <br />
            Team TBD
          </p>

          <div className="consent-card__actions">
            <Button variant="primary" onClick={handleSubmit} disabled={!allChecked} className="consent-card__cta">
              Agree &amp; Continue
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ConsentUpdateModal
